import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Models
import mPlanning from 'models/cpm/planning';
// Custom
import { openDialog } from 'actions';
import { cpmPlanningDataShape } from 'constants/PropTypesShapes';
import { InfoIconButton } from 'components/buttons/IconButtons';

class PlanningInfoButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleShowPlanning = this.handleShowPlanning.bind(this);

    // Initialize working timezone for calendar
    const { timezone } = this.props;
    mPlanning.setWorkingTimezone(timezone);
  }

  // Handlers called by parent (= DialogItem)
  handleShowPlanning() {
    const { planning, handleOpenDialog } = this.props;
    handleOpenDialog({
      title: {
        fixed: mPlanning.title(planning),
      },
      actions: [
        { type: 'close' },
      ],
      component: {
        type: 'CARPARK_PLANNING_INFO',
        props: {
          planning,
        },
      },
      dividers: true,
      size: 'md',
    });
  }

  render() {
    const { planning } = this.props;

    if (planning) {
      return (
        <InfoIconButton
          primary
          tooltipId="tooltip.planningDetails"
          size="small"
          onClick={this.handleShowPlanning}
        />
      );
    }
    return null;
  }
}

PlanningInfoButton.propTypes = {
  timezone: PropTypes.string.isRequired,
  planningId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  planning: cpmPlanningDataShape,
  handleOpenDialog: PropTypes.func.isRequired,
};

PlanningInfoButton.defaultProps = {
  planningId: null,
  planning: null,
};

const mapStateToProps = (state, ownProps) => ({
  timezone: state.cpmCarpark.current.data.timezone,
  planning: _find(state.cpmCarparkPlanning.list.elements, ['id', ownProps.planningId]),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlanningInfoButton);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/plannings/PlanningInfoButton.js